module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJFBMVEUAAAAxMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTHjRZ0/AAAAC3RSTlMA3NYbHxccz77GtubgM0oAAABrSURBVBjTPc6xCYBAEETRAcUGDI0F4ZKzBDuwBduwAUuwDk2uPeEz42bLC/7orvL1i8qYZ2s6nmqYZg3TaHh3QQZBASgAGUxACAgBISBxWonTyipaWUXLQCtA6wcoABlCQKgYpLXpMkjd+QEIvCE0mEjJ9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/phone/close.png
// module id = 12
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22